
import VModal from '@/vuetify_custom/v-modal_v1'
import TFrecords from './TFrecords.jsx'
import VPage from '@/vuetify_custom/v-pagination'
import {VTextField} from 'vuetify/lib'
import AutocompletesAsync from '@/vuetify_custom/v-form/components/Autocompletes_Async_v1.js'
import {contract_types_mixins} from './EditMixIns.jsx'
import {mapGetters} from "vuex";
import { throttle } from '@/libs/functions_utils'
import { getContractRelatedPlacingRecordsApi, getPlacingAdsRecordSelectSearchApi, postContractRelatedPlacingRecordAddApi, getOurceContractRelatedPlacingRecordsApi, postOutsourceContractRelatedPlacingRecordAddApi } from '../service'
import styles from './index.module.less'
export default {
    mixins: [contract_types_mixins],
    props: {
        ContractType: {
            type: String,
        }
    },
    data() {
        return {
            show: false,
            saving: false,
          
            show_type: true,
            show_type_1: true,
            show_type_3: true,
            get_data_loading: false,
            list: [],
            params: {
                id:null,
                page:null,
                per_page:null,
                search:null,
                total_count:0,
            },
            search_list: [],
            pd:{
                key:''
            }
        }
    },
    computed: {
        ...mapGetters('async', [ 'team_company_mapping_hash']),
        // 
        // 合同大类
        attrs_list() {
            const hash = this.contract_types_all_hash && this.contract_types_all_hash.income_expenses_hash || {}
            if (!this.params.contract_sz_type || !hash[this.params.contract_sz_type]) {
                return []
            }
            // 过滤
            const arr = []
            const has_hash = {}
            hash[this.params.contract_sz_type].forEach(item => {
                if (has_hash[item.main_type]) {
                    return 
                }
                has_hash[item.main_type] = true
                arr.push(item)
            });
            return arr
        },
        cur_customer() {
            return this.$store.state.cur_customer;
        },
    },
    created() {
        // 建立引用关系，从后端拉数据
        this.team_company_mapping_hash
  
        this.searchAdd = throttle.call(this, (search) => {
            getPlacingAdsRecordSelectSearchApi({
                query_all: true,
                relate_type: 'contract',
                search
            }).then(res => {
               this.search_list = res
            })
        }, 200)
    },
    methods: {
        getData(params = {}) {
            const _params = {
                ...this.params,
                ...params,
            }
            this.get_data_loading = true
            const getApi = this.ContractType === 'outsource' ? getOurceContractRelatedPlacingRecordsApi : getContractRelatedPlacingRecordsApi
            getApi(_params).then(res => {
                this.list = res.placing_ads_records
                this.params.page = res.cur_page
                this.params.per_page = res.per_page
                this.params.total_count = res.total_count
          }).finally(() => {
              this.get_data_loading = false
          })
        },
        edit(params = {}, other_params) {
            this.show = true
            this.params.id = params.id
            this.getData()
            this.other_params = other_params
        },

    },
    render() {
        const _this = this
        return <VModal
            fullscreen
            dynamicHeight
            heightRate={0.8}
            v-model={_this.show}
            title="投放记录"
            loading={_this.saving}
            // width={1200}
            ref="modal"
            ok-text="关闭"
            cancelText=""
            on={{
                ok: () => {
                    this.show = false
                    if (this.other_params && this.other_params.closeCall) {
                        this.other_params.closeCall()
                        return 
                    }
                },
            }}
        >
            <div style="width:500px;">
               
            <AutocompletesAsync 
                    v-model={this.pd}
                     field={{
                        outlined:true,
                        label: '添加',
                        key: 'key',
                        type:'autocompletes_async_v1',
                        'item-value':'id',
                        'item-text':'dis_text',
                        api: this.$util.api.placing_ads_record_select_search,
                        out_params:{
                            query_all: true,
                            relate_type: 'contract',
                        },
                        handle_data:a => {
                      
                            return a.map(i => ({
                                ...i,
                                dis_text: `${i.estimate_publish_at}/${i.uid}/${i.publish_at}/${i.docking_customer_name}/${i.platform}/${i.sku}`
                            })) 
                        },
                        item_slot: (h, i) => {
                           return <div style="margin:5px;">
                   
                               <p class={styles['item-name']}>{i.uid}</p>
                          
                               <p class={styles['item-o']}>预计投放时间：{i.estimate_publish_at}</p>
                               <p class={styles['item-o']}>发布时间：{i.publish_at}</p>
                         
                               <p class={styles['item-o']}>对接人：{i.docking_customer_name}</p> 
                               <p class={styles['item-o']}>项目组：{i.platform}</p>
                               <p class={styles['item-o']}>SKU：{i.sku.sku_name}</p>
                             <p class={styles['item-o']}>预计投放金额：{i.total_price}</p>
                      
                           </div>
                       },
                       change:(record_id) => {
                        const postApi = this.ContractType === 'outsource' ? postOutsourceContractRelatedPlacingRecordAddApi : postContractRelatedPlacingRecordAddApi
                         
                           postApi({
                            id:  this.params.id,
                            record_id
                        }).then(() => {
                            this.$Message.success('添加成功！')
                            this.getData({
                                cur_page:1,
                               
                              })
                        })
                         setTimeout(() => {
                             this.pd.key = null
                         })
                       }
                     }}
                      />
            </div>
            <div class="hr" />
                     <div style="width:300px;">
                     <VTextField 
                      clearable
                      placeholder="搜索..."
                      v-model={_this.params.search}
                      append-icon="mdi-magnify"
                      on={{
                        'click:clear':() => {
                          _this.getData({
                            cur_page:1,
                            search: null,
                          })
                        },
                        'click:append': () => {

                          _this.getData({
                            cur_page:1,
                           
                          })
                        },
                        'keydown': (e) => {
                          if (e && e.code === 'Enter') {
                              _this.getData({
                                  cur_page:1,
                                 
                                })
                          }
                        },
                      }}
                      />
                     </div>
      
            <TFrecords 
                contractType={this.ContractType}
                list={this.list} 
                loading={this.get_data_loading} 
                pParams={this.params}
                on={{
                delete:() => {
                    this.getData({ cur_page:1, })
                }
            }}/>
            {!!this.params.total_count && <VPage
                current={this.params.page}
                total={this.params.total_count}
                page-size={this.params.per_page}
                size-arr={[10, 20, 50]}
                on={
                  {
                    changePageSize:(per_page) => {
                        this.params.per_page = per_page
                        this.params.page = 1
                        this.$nextTick(this.getData)
                    },
                    pageChange:(page) => {
                        this.params.page = page
                
                        this.$nextTick(this.getData)
                    }
                  }
                }
              />}
        </VModal>
    }
}